<script>
    import PublishTooltipButton from "./publish-tooltip-button.vue";

    export default {
        name: "expansion-panel-header",
        components: {PublishTooltipButton},
        props: {
            tooltipText: String,
            onlyIconCanCollapse: Boolean,
            collapsable: Boolean,
            collapsed: Boolean,
            loading: Boolean,
            icon: String
        },
        computed: {
            translations() {
                return {
                    loading: Lang.langGet("Loading..."),
                    duration: Lang.langGet("Duration")
                }
            },
            expandIcon() {
                if (this.icon) return this.icon;
                return this.collapsed ? 'fas fa-chevrons-down' : 'fas fa-chevrons-up';
            },
            subheaderClass() {
                if (!this.onlyIconCanCollapse && this.collapsable) {
                    return 'creator-title-text d-flex justify-space-between cursor-pointer creator-title-text-clickable';
                }
                return 'creator-title-text d-flex justify-space-between';
            }
        },
        methods: {
            handleHeaderClick(event) {
                if (!this.collapsable) return null;
                if (this.onlyIconCanCollapse) return null;
                return this.$emit('click', event);
            }
        }
    }
</script>

<template>
    <v-subheader
        :aria-label="!onlyIconCanCollapse && collapsable ? tooltipText : undefined"
        :class="subheaderClass"
        :type="!onlyIconCanCollapse && collapsable ? 'button' : undefined"
        @click="handleHeaderClick"
    >
        <strong class="creator-title expansion-panel-title text-truncate">
            <template v-if="loading">
                <i class="fa-regular fa-spinner fa-spin-pulse"/>
                {{ translations.loading }}
            </template>
            <template v-else>
                <slot/>
            </template>
        </strong>

        <v-card-actions v-if="collapsable">
            <publish-tooltip-button
                @click.stop="$emit('click', $event)"
                :icon="expandIcon"
                :tooltipText="tooltipText"
            />
        </v-card-actions>
    </v-subheader>
</template>

<style scoped>
    .expansion-panel-title {
        color: black;
        width: 80%;
        padding-block: 4px;
        display: block;
    }
</style>
